import createdBy from './createdBy'
import fromField from './fromField'
import toField from './toField'
import statusColumn from './status'
import memo from './memo'
import id from './id'
import items from './items'
import totalCost from './totalCost'
import totalWac from './totalWac'
import date from './date'
import { EuiBasicTableColumn } from '@equipmentshare/ds2'

export default function getColumns( useDate?: boolean, showWac?: boolean ): EuiBasicTableColumn<any>[] {
	return [
		...( useDate ? [ date ] : [] ),
		id,
		statusColumn,
		fromField,
		toField,
		memo,
		items,
		...showWac ? [ totalWac ] : [ totalCost ],
		createdBy,
	]
}
